import { Link } from "react-router-dom";
import { aboutParagraphs } from "@/mocks/site";

export default function Intro() {
  return (
    <section id="about" className="scroll-mt-28 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="reveal lg:col-span-7">
            <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.18em] text-secondary-700">
              <span className="h-px w-8 bg-gradient-to-r from-secondary-400 to-accent-400" aria-hidden="true"></span>
              Our Approach
            </span>
            <h2 className="mt-5 font-heading text-3xl font-semibold leading-[1.12] text-foreground-950 md:text-5xl">
              Specialist Care.
              <br />
              Personal Attention.
              <br />
              <span className="text-gradient-brand">Better Understanding.</span>
            </h2>
          </div>

          <div className="reveal lg:col-span-5">
            <div className="space-y-4 border-l-2 border-secondary-200 pl-6">
              {aboutParagraphs.slice(0, 2).map((paragraph) => (
                <p key={paragraph.slice(0, 24)} className="font-body text-sm leading-relaxed text-foreground-600 md:text-base">
                  {paragraph}
                </p>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-7 inline-flex cursor-pointer items-center gap-2 font-label text-sm font-semibold text-primary-700 transition-colors hover:text-primary-800"
            >
              Discover Our Approach
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}